import { faXmark } from '@fortawesome/pro-light-svg-icons';
import { faImagePolaroid } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Masonry from '@mui/lab/Masonry';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './POLMasonry.scss';

const POLMasonry = ({
    onDeleteClick,
    photos,
    showDeleteIcon,
    showNoImage,
    onImgClick,
    isHidden,
}) => {
    if (isEmpty(photos) && !showNoImage) {
        return null;
    }

    return (
        <div>
            {!isEmpty(photos) && (
                <Masonry
                    className={styles.photosContainer}
                    columns={4}
                    spacing={2}
                >
                    {photos.map((currentPhoto, index) => {
                        const content = (
                            <>
                                <img
                                    alt={`User graphic ${index + 1}`}
                                    src={currentPhoto.thumbnailUrl}
                                />
                                {showDeleteIcon && (
                                    <button
                                        className={classNames(styles.photoIcon, styles.removeBtnStyles)}
                                        onClick={() => onDeleteClick(currentPhoto)}
                                        type="button"
                                        aria-label="Delete Image"
                                        disabled={isHidden}
                                    >
                                        <FontAwesomeIcon
                                            icon={faXmark}
                                            className={
                                                classNames(styles.iconSize, styles.textLink)
                                            }
                                        />
                                    </button>
                                )}
                            </>
                        );

                        if (showDeleteIcon) {
                            return (
                                <div
                                    key={currentPhoto.id}
                                    className={styles.photoItem}
                                >
                                    {content}
                                </div>
                            );
                        }

                        return (
                            <button
                                key={currentPhoto.id}
                                className={classNames(styles.photoItem, styles.removeBtnStyles)}
                                onClick={() => onImgClick(index)}
                                type="button"
                                disabled={isHidden}
                            >
                                {content}
                            </button>
                        );
                    })}
                </Masonry>
            )}
            {isEmpty(photos) && showNoImage && (
                <div className={styles.noImage}>
                    <FontAwesomeIcon icon={faImagePolaroid} className={styles.image} />
                    <div className={styles.text}>No Images Yet!</div>
                </div>
            )}
        </div>
    );
};

POLMasonry.propTypes = {
    showNoImage: PropTypes.bool,
    showDeleteIcon: PropTypes.bool,
    onDeleteClick: PropTypes.func,
    onImgClick: PropTypes.func,
    photos: PropTypes.arrayOf(PropTypes.object),
    isHidden: PropTypes.bool,
};

POLMasonry.defaultProps = {
    showNoImage: false,
    showDeleteIcon: false,
    onDeleteClick: () => {},
    onImgClick: () => {},
    photos: [],
    isHidden: false,
};

export default POLMasonry;
